import { jsonHeaders, jsonResult } from "./index.js";
import { BACKEND_PREFIX as backendPrefix } from "#src/env.js";

async function createStripeCheckoutSession(props) {
  const res = await fetch(`${backendPrefix}/stripe/session`, {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify(props),
  });

  return jsonResult(res);
}

async function getStripeTransactions(orgId, page = 0) {
  const res = await fetch(
    `${backendPrefix}/stripe/transactions/${orgId}?page=${page}`,
    {
      method: "GET",
      headers: jsonHeaders(),
    },
  );

  return jsonResult(res);
}

async function getStripeCheckoutSession(sessionId) {
  const res = await fetch(`${backendPrefix}/stripe/session/${sessionId}`, {
    method: "GET",
    headers: jsonHeaders(),
  });

  return jsonResult(res);
}

async function getBalances(orgId) {
  const res = await fetch(`${backendPrefix}/stripe/balances/${orgId}`, {
    method: "GET",
    headers: jsonHeaders(),
  });

  return jsonResult(res);
}

async function getPrices(orgId) {
  const res = await fetch(`${backendPrefix}/stripe/prices/${orgId}`, {
    method: "GET",
    headers: jsonHeaders(),
  });

  return jsonResult(res);
}

async function getCustomerId(orgId) {
  const res = await fetch(`${backendPrefix}/stripe/customer/${orgId}`, {
    method: "GET",
    headers: jsonHeaders(),
  });

  return jsonResult(res);
}

async function purchasePackage(organizationId, priceId) {
  const res = await fetch(`${backendPrefix}/stripe/purchase`, {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify({ organizationId, priceId }),
  });

  return jsonResult(res);
}

export {
  createStripeCheckoutSession,
  getStripeTransactions,
  getBalances,
  getPrices,
  getCustomerId,
  purchasePackage,
  getStripeCheckoutSession,
};
